<template>
  <div class="inputs" ref="inputs">
    <div v-if="filterpercent">
      <eco-input
        :width="width"
        style="width: 100%"
        size="small"
        auto-complete="off"
        :validate="inputValidate"
        :placeholder="placeholder ? placeholder : '请输入内容'"
        clearable
        v-model="inputValPercent"
        :model-expression="modelExpression"
        :name="inputName"
        :ref="atter"
        :type="type"
        :show-password="
          configAttributes && configAttributes.isPassword
            ? configAttributes && configAttributes.isPassword
            : false
        "
        :math-exp="mathExp"
        :date-calc-exp="dateCalcExp"
        :min="min"
        :max="max"
        :step="step"
        :step-strictly="stepStrictly"
        :precision="precision"
        :disabled="!isEdit"
        :permission="permission"
        v-if="product"
        @blur="numberBlur"
        @change="numberChange"
        :format="format"
        :readonly-format="readonlyFormat"
        :class.once="[preData !== inputValPercent ? 'red' : '']"
      >
        <template
          v-if="
            bindPreAndSufFix && bindPreAndSufFix.preFix && permission != 'r'
          "
          v-slot:prepend
        >
          <span>{{ bindPreAndSufFix.preFix }}</span>
        </template>
        <template
          v-if="
            ((bindPreAndSufFix && bindPreAndSufFix.sufSix) || company) &&
              permission != 'r'
          "
          v-slot:append
        >
          <span v-if="company">{{ company }}</span>
          <span v-else>{{ bindPreAndSufFix.sufSix }}</span>
        </template>
      </eco-input>
      <el-input
        v-if="!product"
        v-model="thousandBitP"
        autocomplete="off"
        @focus="numberFocus"
        size="small"
        :disabled="!isEdit || permission == 'r'"
      ></el-input>
    </div>
    <div v-else-if="configAttributes && configAttributes.isMap">
      <eco-input
        :width="width"
        style="width: 90%"
        size="small"
        auto-complete="off"
        :validate="inputValidate"
        :placeholder="placeholder ? placeholder : '请输入内容'"
        clearable
        v-model="inputVal"
        :model-expression="modelExpression"
        :name="inputName"
        :ref="atter"
        :type="type"
        :math-exp="mathExp"
        :date-calc-exp="dateCalcExp"
        :min="min"
        :max="max"
        :step="step"
        :step-strictly="stepStrictly"
        :precision="precision"
        :disabled="!isEdit"
        :permission="permission"
        @focus="showMap"
        :format="format"
        :readonly-format="readonlyFormat"
      >
        <template
          v-if="
            bindPreAndSufFix && bindPreAndSufFix.preFix && permission != 'r'
          "
          v-slot:prepend
        >
          <span>{{ bindPreAndSufFix.preFix }}</span>
        </template>
        <template
          v-if="
            ((bindPreAndSufFix && bindPreAndSufFix.sufSix) || company) &&
              permission != 'r'
          "
          v-slot:append
        >
          <span v-if="company">{{ company }}</span>
          <span v-else>{{ bindPreAndSufFix.sufSix }}</span>
        </template>
      </eco-input>
      <el-button
        icon="el-icon-map-location"
        @click="showMap"
        type="text"
        class="mapBtn"
      ></el-button>
      <el-dialog
        :close-on-click-modal="false"
        width="70%"
        title="地图"
        class="sp-manager__dialog"
        :visible="mapDialogVis"
        :before-close="beforeCloseDialog"
        @closemap="beforeCloseDialog"
      >
        <div slot="title" class="dialog-header-title">
          <span class="name">地图</span>
        </div>
        <eip-map :addressMap="atter" :heightMap="400" v-if="mapDialogVis" />
      </el-dialog>
    </div>
    <div v-else>
      <eco-input
        :width="width"
        style="width: 100%"
        size="small"
        auto-complete="off"
        :validate="inputValidate"
        :placeholder="placeholder ? placeholder : '请输入内容'"
        clearable
        v-model="inputVal"
        :model-expression="modelExpression"
        :name="inputName"
        :ref="atter"
        :type="type"
        :show-password="
          configAttributes && configAttributes.isPassword
            ? configAttributes && configAttributes.isPassword
            : false
        "
        :math-exp="mathExp"
        :date-calc-exp="dateCalcExp"
        :min="min"
        :max="max"
        :step="step"
        :step-strictly="stepStrictly"
        :precision="precision"
        :disabled="!isEdit"
        :permission="permission"
        v-show="isShow"
        @blur="numberBlur"
        @change="numberChange"
        :format="format"
        :readonly-format="readonlyFormat"
      >
        <template
          v-if="
            bindPreAndSufFix && bindPreAndSufFix.preFix && permission != 'r'
          "
          v-slot:prepend
        >
          <span>{{ bindPreAndSufFix.preFix }}</span>
        </template>
        <template
          v-if="
            ((bindPreAndSufFix && bindPreAndSufFix.sufSix) || company) &&
              permission != 'r'
          "
          v-slot:append
        >
          <span v-if="company">{{ company }}</span>
          <span v-else>{{ bindPreAndSufFix.sufSix }}</span>
        </template>
      </eco-input>

      <el-input
        v-if="!isShow"
        v-model="thousandBit"
        :class="showRed ? 'thous' : ''"
        autocomplete="off"
        @focus="numberFocus"
        size="small"
        :disabled="!isEdit || permission == 'r'"
      ></el-input>
      <el-input
        v-if="filtercurrency && (permission == 'w' || permission == 'b')"
        v-model="showViewe"
        autocomplete="off"
        :disabled="true"
        size="small"
        class="currcy"
      >
        <template v-if="company && permission != 'r'" slot="append">{{
          company
        }}</template>
      </el-input>
    </div>
    <fe-field-tail
      :fieldName="inputName"
      :readonly="false"
      ref="inputErr"
      :inputValue="inputVal"
      v-if="!isShow"
    >
      <slot name="append" slot="append"></slot>
    </fe-field-tail>
  </div>
</template>
<script>
import utils from "@/utils.js";
import FormMath from "@/math.js";
import { Message } from "element-ui";
import _ from "lodash";

export default {
  components: {},
  name: "eip-input",
  props: [
    "validate",
    "value",
    "name",
    "modelExpression",
    "permission",
    "mathExp",
    "atter",
    "type",
    "dateCalcExp",
    "configAttributes",
    "placeholder",
    "precision",
    "stepStrictly",
    "min",
    "max",
    "filterpercent",
    "filterthousandBit",
    "filtercurrency",
    "step",
    "bindPreAndSufFixjson",
    "company",
    // 以前的数据
    "preData",
    // 判断是否存在
    {
      isShowDiff: {
        type: Boolean,
        default: false
      }
    }
  ],
  data() {
    return {
      width: "100%",
      inputValPercent: "0",
      unwatchAry: [],
      isEdit: true,
      showViewe: "",
      thousandBit: "0",
      format: "",
      isShow: true,
      pattern: /[1-9]\d*.\d*|0.\d*[1-9]\d*/,
      checknumber: /(^[\-0-9][0-9]*(.[0-9]+)?)$/,
      identityMap: {},
      newValidate: null,
      bindPreAndSufFix: null,
      isOne: true,
      product: true,
      thousandBitP: "0",
      mapDialogVis: false,
      showRed: false
    };
  },
  watch: {
    errors: {
      handler(newVal, oldVal) {
        if (newVal.items && newVal.items.length > 0) {
          const this_ = this;
          if (!this_.isShow) {
            const index = newVal.items.find(m => m.field == this_.inputName);

            if (index) {
              if (this_.$refs.inputErr.errorMessage) {
                this_.showRed = true;
              } else {
                this_.showRed = false;
              }
            } else {
              this_.showRed = false;
            }
          } else {
            this_.showRed = false;
          }
        } else {
          this.showRed = false;
        }
      },
      deep: true,
      immediate: true
    },
    inputVal: {
      handler: function(newVal, oldVal) {
        if (newVal || newVal == 0 || newVal == undefined) {
          if (this.filtercurrency && this.pattern.test(newVal)) {
            this.showViewe = FormMath.convertCurrency(newVal);
          }
          if (this.filterthousandBit && this.checknumber.test(newVal)) {
            this.isShow = false;
            this.thousandBit = utils.thousandBit(parseFloat(newVal).toFixed(2));
          }
          if (this.filterthousandBit && (newVal == 0 || newVal == undefined)) {
            this.thousandBit = "0";
            this.inputVal = 0;
          }
        }
      },
      deep: true,
      immediate: true
    },
    thousandBit: {
      handler: function(newVal, oldVal) {
        if ((newVal || newVal == 0) && newVal != oldVal) {
          if (this.filterpercent && this.checknumber.test(newVal)) {
            this.thousandBitP = parseFloat(newVal).toFixed(2);
          }
          this.$validator = this.$root.$validator;
        }
      },
      deep: true,
      immediate: true
    },
    inputValPercent: {
      handler: function(newVal, oldVal) {
        if (
          (newVal || newVal == undefined || newVal == 0) &&
          newVal != oldVal
        ) {
          if (this.filterpercent && this.checknumber.test(newVal)) {
            this.product = false;
            this.thousandBit = parseFloat(newVal);
            this.$emit("input", parseFloat(this.thousandBit) / 100);
          }
        }
      },
      deep: true,
      immediate: true
    },
    value: {
      handler(newVal, oldVal) {
        if (
          (newVal || newVal == 0 || newVal == undefined) &&
          newVal != oldVal
        ) {
          if (this.filterpercent) {
            this.product = false;
            if (newVal) {
              this.inputValPercent = String(parseFloat(newVal) * 100);
            } else {
              this.inputValPercent = "0";
              this.thousandBitP = "0";
            }
          }
        }
      },
      deep: true,
      immediate: true
    }
  },
  computed: {
    inputVal: {
      get() {
        return this.value;
      },
      set(val) {
        if (this.type == "number") {
          if (this.filterpercent) {
            if (this.product) {
              this.$emit("input", parseFloat(val));
            } else {
              this.$emit("input", parseFloat(val) * 100);
            }
          } else {
            this.$emit(
              "input",
              val ? parseFloat(val).toFixed(this.precision) : 0
            );
          }
        } else {
          this.$emit("input", val);
        }
      }
    },
    inputName: function() {
      let labeldesc = "";
      if (
        this.$slots &&
        this.$slots.labeldesc &&
        this.$slots.labeldesc[0].children &&
        this.$slots.labeldesc[0].children[0].text
      ) {
        labeldesc = this.$slots.labeldesc[0].children[0].text;
        return this.name ? this.name : utils.getName() + "-" + labeldesc;
      } else {
        return this.name ? this.name : utils.getName();
      }
    },
    inputValidate: function() {
      if (this.newValidate) {
        return this.newValidate;
      }
      return this.validate;
    }
  },
  // checkNumber: function (val) {
  //   var reg = /^[0-9]+\.?[0-9]*$/;
  //   if (reg.test(val)) {
  //     return true;
  //   }
  //   return false;
  // },
  async mounted() {
    const _me = this;
    // const pInst = utils.getOnlineFormInstance(_me);
    //检查流水号
    if (this.configAttributes) {
      if (this.configAttributes.isInputEdit) {
        this.isEdit = !this.configAttributes.isInputEdit;
      } else {
        this.isEdit = true;
      }

      //判断是否绑定流水号
      if (this.configAttributes.bindIdentityAlias) {
        this.isEdit = false;
        if (this.value) return;
        var alias = this.configAttributes.bindIdentityAlias;
        const res = await this.$store.dispatch("menu/getNextIdByAlias", alias);
        if (res.state) {
          this.$emit("input", res.value);
          if (res.value) {
            var match = /(\{(.*)\}).*$/.exec(res.value);
            //判断流水号中是否表达式如{kjbt.csfjsc}
            if (match) {
              this.$emit("input", res.value.replace(match[1], ""));
              let paramDom = document.querySelector(
                '[model-name="data.' + match[2] + '"]'
              );
              let _me = this;
              if (paramDom && paramDom.__vue__) {
                paramDom.__vue__.$watch("value", function(newVal, oldVal) {
                  if (_me.modelExpression == paramDom.__vue__.modelExpression) {
                    Message.error("流水号生成规则字段不能绑定流水号显示字段");
                    return;
                  }
                  if (newVal != oldVal) {
                    _me.$emit("input", res.value.replace(match[1], newVal));
                    //_me.inputVal=res.value.replace(match[1],newVal);
                  }
                });
              }
              //this.$emit("input", res.value.replace(match[1], ""));
              // pInst.identityMap = pInst.identityMap || {};
              // pInst.identityMap["data." + match[2]] = {
              //   //建模别名与实体名不同 {实体.字段} 时使用 this.atter会导致无法返回，故改为this.modelExpression
              //   key: this.modelExpression,
              //   value: res.value,
              //   expression: match[1]
              // };
            }
          }
        } else {
          //Message.error(res.message);
        }
      }
    } else {
      this.isEdit = true;
    }

    if (this.filtercurrency && this.pattern.test(this.inputVal)) {
      this.format = FormMath.convertCurrency(this.inputVal);
    }
    if (this.filterthousandBit && this.pattern.test(this.inputVal)) {
      this.format = this.format + "   " + utils.thousandBit(this.inputVal);
    }
    if (this.filterpercent && this.pattern.test(this.inputVal)) {
      this.format = this.format + "   " + parseFloat(this.inputVal);
    }
    if (this.bindPreAndSufFixjson) {
      if (typeof this.bindPreAndSufFixjson == "string") {
        this.bindPreAndSufFix = JSON.parse(this.bindPreAndSufFixjson);
      }
    }
  },
  methods: {
    beforeCloseDialog() {
      this.mapDialogVis = false;
    },
    showMap() {
      this.mapDialogVis = true;
    },
    readonlyFormat(val) {
      //暂无表达式 如有表达式使用  eval(val) 并且控件配置项要把表达式构建传递到eipInput
      if (this.bindPreAndSufFix) {
        if (!this.bindPreAndSufFix.preFix) {
          this.bindPreAndSufFix.preFix = "";
        }
        if (!this.bindPreAndSufFix.sufSix) {
          this.bindPreAndSufFix.sufSix = "";
        }
        if (this.value) {
          return (
            this.bindPreAndSufFix.preFix +
            this.value +
            this.bindPreAndSufFix.sufSix
          );
        }
      } else if (this.company) {
        return this.value + this.company;
      }
    },
    numberBlur() {
      if (this.filtercurrency && this.pattern.test(this.inputVal)) {
        this.isShow = false;
        this.showViewe = FormMath.convertCurrency(this.inputVal);
      }
      if (this.filterthousandBit && this.pattern.test(this.inputVal)) {
        this.isShow = false;
        this.thousandBit = utils.thousandBit(this.inputVal);
      }
      if (this.filterpercent && this.pattern.test(this.inputValPercent)) {
        this.product = false;
        this.thousandBit = parseFloat(this.inputValPercent);
      }
    },
    numberFocus() {
      if (this.filtercurrency && this.checknumber.test(this.inputVal)) {
        this.isShow = true;
      }
      // this.inputVal = this.thousandBit; isShow转变
      if (
        this.filterthousandBit &&
        ((this.inputVal && this.checknumber.test(this.inputVal)) ||
          !this.inputVal)
      ) {
        this.inputVal = this.thousandBit
        this.$emit("input", this.inputVal);
        this.isShow = true;
      }
      if (this.filterpercent && this.checknumber.test(this.inputValPercent)) {
        this.inputValPercent = this.thousandBit;
        this.product = true;
      }
    },
    convertCurrency: _.debounce(function() {
      if (this.filtercurrency && this.pattern.test(this.inputVal)) {
        this.isShow = false;
        this.showViewe = FormMath.convertCurrency(this.inputVal);
      }
    }, 1000),
    convertThousanBit: _.debounce(function() {
      if (this.filterthousandBit && this.pattern.test(this.inputVal)) {
        this.thousandBit = utils.thousandBit(this.inputVal);
      }
    }, 1000),
    convertPercent: _.debounce(function() {
      if (this.filterpercent && this.pattern.test(this.inputValPercent)) {
        this.thousandBit = parseFloat(this.inputValPercent);
      }
    }, 1000),
    numberChange() {
      if (this.filtercurrency && this.checknumber.test(this.inputVal)) {
        this.convertCurrency();
      }
      if (this.filterthousandBit && this.checknumber.test(this.inputVal)) {
        this.convertThousanBit();
      }
      if (this.filterpercent && this.checknumber.test(this.inputValPercent)) {
        this.convertPercent();
      }
    }
  },
  beforeDestroy() {},
  destroyed() {},
  created() {}
};
</script>
<style lang="stylus" scoped>
div[aria-invalid='true'] >>> .el-input__inner, div[aria-invalid='true'] >>> .el-input__inner:focus {
  border-color: #f56c6c;
}

.widthCalc {
  width: calc(100% - 30px);
  float: left;
}

.danwei {
  width: 30px;
}
</style>
<style>
.mapBtn i {
  font-size: 20px;
  margin-left: 10px;
}
.currcy .el-input-group__append {
  padding: 0 9px !important;
}
.currcy .el-input__inner {
  border-right: 0;
}
.el-input-number__decrease {
  display: none;
}
.el-input-number__increase {
  display: none;
}
.thous .el-input__inner {
  border-color: #f56c6c;
}
</style>
